/**
 * Clear Graduated Students ClassIds
 * Removes classId and className from graduated/inactive students
 * so they don't appear in current class lists
 *
 * USAGE: await window.clearGraduatedStudents()
 */

import { collection, getDocs, updateDoc, doc } from 'firebase/firestore';
import { db } from '../firebase.js';

async function clearGraduatedStudents() {
  console.log('🎓 Clearing classId from graduated students...\n');

  try {
    // Get schoolId from localStorage (this is set by SchoolContext)
    const contextData = localStorage.getItem('swan_school_context');
    if (!contextData) {
      console.error('❌ No school context found. Make sure you\'re logged in.');
      return { success: false, error: 'No school context' };
    }

    const { schoolId } = JSON.parse(contextData);
    if (!schoolId) {
      console.error('❌ No schoolId in context.');
      return { success: false, error: 'No schoolId' };
    }

    console.log(`📚 School ID: ${schoolId}`);

    // Query for all students in the school
    const studentsRef = collection(db, `schools/${schoolId}/students`);
    const snapshot = await getDocs(studentsRef);

    console.log(`Found ${snapshot.size} total students`);

    // Find graduated/inactive students with classId still set
    const toFix = [];
    snapshot.forEach(doc => {
      const student = { id: doc.id, ...doc.data() };
      if ((student.status === 'graduated' || student.status === 'inactive') && student.classId) {
        toFix.push(student);
      }
    });

    console.log(`Found ${toFix.length} graduated/inactive students with classId set`);

    if (toFix.length === 0) {
      console.log('✅ No students need fixing!');
      return { success: true, fixed: 0 };
    }

    // Clear classId and className from each
    console.log('\nClearing class info from:');
    for (const student of toFix) {
      console.log(`- ${student.firstName} ${student.surname} (${student.status}, was in ${student.className || 'unknown class'})`);

      const studentRef = doc(db, `schools/${schoolId}/students`, student.id);
      await updateDoc(studentRef, {
        classId: null,
        className: null
      });
    }

    console.log('\n✅ Complete! Graduated/inactive students no longer have classIds.');
    return { success: true, fixed: toFix.length };

  } catch (error) {
    console.error('❌ Error:', error);
    throw error;
  }
}

export { clearGraduatedStudents };